<template>
  <div class="step-container payment-success-message">
    <div class="success-card bg-white rounded-xl p-8 text-center shadow-lg border border-green-100">
      <div class="icon-wrapper">
        <div class="success-icon-container mb-6">
          <div class="success-icon-circle">
            <font-awesome-icon 
              :icon="['fas', 'check']" 
              class="check-icon"
            />
          </div>
        </div>
      </div>
      
      <h2 class="text-3xl font-bold text-gray-800 mb-4">{{ $translate('Thank You for Your Order!') }}</h2>
      
      <p class="text-xl text-gray-600 mb-8">
        {{ $translate('Your payment has been successfully processed.') }}
      </p>
      
      <div class="details bg-green-50 p-6 rounded-lg text-left mb-8 shadow-sm border border-green-100">
        <p class="mb-4 flex items-start">
          <font-awesome-icon :icon="['fas', 'envelope']" class="text-green-600 mr-3 mt-1 flex-shrink-0" />
          <span>{{ $translate('A confirmation email has been sent to your email address.') }}</span>
        </p>
        <p class="mb-4 flex items-start">
          <font-awesome-icon :icon="['fas', 'file-invoice']" class="text-green-600 mr-3 mt-1 flex-shrink-0" />
          <span>{{ $translate('You can download your invoice from your account page.') }}</span>
        </p>
        <p class="flex items-start">
          <font-awesome-icon :icon="['fas', 'calendar-check']" class="text-green-600 mr-3 mt-1 flex-shrink-0" />
          <span>{{ $translate('The event has been added to your account. You can access it anytime.') }}</span>
        </p>
      </div>
      
      <router-link 
        :to="{ name: 'EventPage', params: { type: resolvedEventType, id: resolvedEventId } }"
        class="back-button bg-green-600 hover:bg-green-700 text-white py-3 px-8 rounded-lg inline-flex items-center transition-all duration-200"
      >
        <font-awesome-icon :icon="['fas', 'arrow-left']" class="mr-2" />
        {{ $translate('Back to Event Page') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';

export default {
  name: 'PaymentSuccessMessage',
  inheritAttrs: false,
  props: {
    eventId: {
      type: String,
      default: null
    },
    eventType: {
      type: String,
      default: null
    },
    attendee: {
      type: Object,
      required: false,
    },
    products: {
      type: Object,
      required: false,
    },
    userEmail: {
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    }
  },
  emits: ['next-step', 'confirm', 'remove-item', 'refresh-attendee', 'pay'],
  setup(props) {
    const route = useRoute();
    
    // If props are not provided, get from route
    const resolvedEventId = props.eventId || route.params.id;
    const resolvedEventType = props.eventType || route.params.type;
    
    return {
      resolvedEventId,
      resolvedEventType
    };
  }
};
</script>

<style scoped>
.payment-success-message {
  max-width: 800px;
  margin: 2rem auto;
}

.success-card {
  position: relative;
  overflow: hidden;
  background-image: radial-gradient(circle at top right, rgba(16, 185, 129, 0.05) 0%, transparent 30%),
                   radial-gradient(circle at bottom left, rgba(16, 185, 129, 0.05) 0%, transparent 30%);
}

.icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
}

.success-icon-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 2.5rem;
}

.success-icon-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  background-color: #10b981;
  border-radius: 50%;
  box-shadow: 0 0 0 15px rgba(16, 185, 129, 0.15);
  position: relative;
  animation: scale-in 0.5s ease-out forwards;
}

.check-icon {
  color: white;
  font-size: 50px;
  transform: scale(0);
  animation: check-animation 0.5s cubic-bezier(0.3, 1.5, 0.7, 1) 0.25s forwards;
}

@keyframes scale-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes check-animation {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.details {
  border-left: 4px solid #10b981;
}

.back-button {
  transition: all 0.2s;
  font-weight: 600;
  box-shadow: 0 4px 6px rgba(16, 185, 129, 0.2);
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(16, 185, 129, 0.25);
}
</style>